import { render } from "./IndovinaMappaView.vue?vue&type=template&id=a20c1c10&class=template"
import script from "./IndovinaMappaView.vue?vue&type=script&lang=js"
export * from "./IndovinaMappaView.vue?vue&type=script&lang=js"

import "./IndovinaMappaView.vue?vue&type=style&index=0&id=a20c1c10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__